import React from 'react';
import { lifecycle, compose, branch, renderComponent } from 'recompose';
import { Spinner } from '@blueprintjs/core';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { createStructuredSelector } from 'reselect'

import { getConfig } from '../../selectors';
import { withSpinner } from '../../utils/hocs';
import * as selectors from '../../selectors/dashboard-selectors';
import * as actions from '../../actions';
import Dashboard from '../../views/dashboard';

const withConnect = connect(
  createStructuredSelector({
    config: getConfig,
    dashboardData: selectors.getDashboardData,
    yearsRange: selectors.getSearchYearsRange,
    loadedSearchQuery: selectors.getLoadedQuery,
    isLoading: selectors.getIsLoaing,
    searchQuery: selectors.getSearchQuery,
  }),
  { ...actions }
);

const withData = lifecycle({
  componentWillReceiveProps(nextProps) {
    const { searchQuery, fetchDashboard } = this.props;
    const { searchQuery: nextSearchQuery } = nextProps;
    if (!isEqual(searchQuery, nextSearchQuery)) {
      fetchDashboard(nextSearchQuery);
    }
  },
  componentDidMount() {
    const { searchQuery, fetchDashboard } = this.props;
    fetchDashboard(searchQuery);
  }
});

export default compose(
  withConnect,
  withData,
  withSpinner(({ dashboardData }) => !dashboardData),
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js